var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSLetterMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sLetMobile",
    width: 29,
    height: 34,
    viewBox: "0 0 29 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.895752 29.5722L3.30819 24.9619C6.10153 26.8828 10.4185 28.2916 14.6085 28.2916C20.0683 28.2916 22.2267 26.6267 22.2267 23.8093C22.2267 16.5095 1.78454 22.7847 1.78454 9.85014C1.78454 3.95913 6.99032 0.117172 15.2434 0.117172C19.4334 0.117172 24.2583 1.26976 27.0516 3.06268L24.5122 7.67303C21.5919 5.75205 18.4176 5.11172 15.2434 5.11172C10.1646 5.11172 7.62517 7.0327 7.62517 9.59401C7.62517 17.2779 28.0674 11.0027 28.0674 23.6812C28.0674 29.5722 22.7346 33.2861 14.1007 33.2861C8.89487 33.4142 3.56213 31.7493 0.895752 29.5722Z",
    fill: "#FF6060"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSLetterMobile);
export default __webpack_public_path__ + "static/media/sLetterMobile.c2137c9c36ee7eb08d5753617a276a66.svg";
export { ForwardRef as ReactComponent };